import React from 'react'
import { Modal } from 'react-bootstrap'
import PropTypes from 'prop-types'

const OneClickPaymentConsentTerms = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton >
        <Modal.Title id="contained-modal-title-vcenter">
          <h2>Medgivande till betalning via Autogiro</h2>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <span className="paragraph-regular-14">
          Undertecknad (”betalaren”), medger att betalning får göras genom uttag från angivet konto eller av betalaren senare angivet konto,
          på begäran av angiven betalningsmottagare för betalning till denne på viss dag (”förfallodagen”) via Autogiro. Betalaren samtycker till
          att behandling av personuppgifter som lämnats i detta medgivande behandlas av betalarens betaltjänstleverantör, betalningsmottagaren,
          betalningsmottagarens betaltjänstleverantör och Bankgirocentralen BGC AB för administration av tjänsten. Personuppgiftsansvariga för
          denna personuppgiftsbehandling är betalarens betaltjänstleverantör, betalningsmottagaren samt betalningsmottagarens betaltjänstleverantör.
          Betalaren kan när som helst begära att få tillgång till eller rättelse av personuppgifterna genom att kontakta betalarens betaltjänstleverantör.
          Ytterligare information om behandling av personuppgifter i samband med betalningar kan finnas i villkoren för kontot och i avtalet med
          betalningsmottagaren. Betalaren kan när som helst återkalla sitt samtycke, vilket medför att tjänsten i sin helhet avslutas.
          <br /><br />
          <h3>Information om betalning</h3>
          Betalaren kommer av betalningsmottagaren att meddelas belopp, förfallodag och alternativ på betalningssätt senast åtta bankdagar före
          förfallodagen på fakturan. Detta meddelas inför varje enskild förfallodag och betalaren behöver aktivt välja betalningssätt för varje
          enskild faktura. Genom undertecknandet av detta medgivande lämnar betalaren sitt samtycke till att betalningar som omfattas av betalningsmottagarens
          meddelande enligt denna punkt genomförs.
        </span>
      </Modal.Body>
    </Modal>
  )
}

OneClickPaymentConsentTerms.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired
}

export default OneClickPaymentConsentTerms
